// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();

    // ** State
    const [valStaff, setValStaff] = useState<any>(null)
    const [listStaff, setListStaff] = useState<any[]>([])

    const [valProfitCenter, setValProfitCenter] = useState<any>(null)
    const [listProfitCenter, setListProfitCenter] = useState<any[]>([])

    useEffect(() => {
        getDetail()
    }, [])

    const getDetail = () => {
        const url = apiUrl.apiUrl + '/sales/salesman/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setValue('nama', data.nama)
                    setValue('is_aktif', data.is_aktif)

                    getStaff(data.nama)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getStaff = (nama: any) => {
        const url = apiUrl.apiUrl + '/hr/staff/list-combo/' + cabang
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.nama == nama) {
                            setValStaff(element)
                            setValue('hrstaff_id', element.id)
                        }
                    });
                    setListStaff(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const navigate = useNavigate();

    interface FormInputs {
        syscabang_id: any,
        accprofitcenter_id: any,
        hrstaff_id: any,
        nama: any,
        is_aktif: any,
    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })


    const handleChangeAutocompleteStaff = (event: SyntheticEvent, newValue: any | null) => {
        setValue('hrstaff_id', newValue?.id)
        setValue('nama', newValue?.nama)
        setValStaff(newValue)
    }

    const handleChangeAutocompleteProfitCenter = (event: SyntheticEvent, newValue: any | null) => {
        setValue('accprofitcenter_id', newValue?.id)
        setValProfitCenter(newValue)
    }

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/salesman/edit/' + id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/sales/master-salesman')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Master Salesman
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ m: 0 }} />

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nama Sales
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='hrstaff_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valStaff}
                                                options={listStaff}
                                                id='hrstaff_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteStaff}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Nama Staff'
                                                        error={Boolean(errors.hrstaff_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.hrstaff_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Profit Center
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='accprofitcenter_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valProfitCenter}
                                                options={listProfitCenter}
                                                id='accprofitcenter_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteProfitCenter}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Profit Center'
                                                        error={Boolean(errors.accprofitcenter_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.accprofitcenter_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                            Aktif ?
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_aktif'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_aktif ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='Aktif ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_aktif && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
